import React from 'react';
import { Provider } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import map from 'lodash/map';

import configureStore from './store';
import history from './history';
import PrivateRoute from '@components/snippets/PrivateRoute';
import LicenseExpire from '@components/snippets/LicenseExpire';
import routes, { authRoutes, Path } from './routes';

import Layout from '@components/layout';
import SettingsProvider from '@components/SettingsProvider';

const store = configureStore({}, history);

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <SettingsProvider>
          {({ isTrial, expireDate }) => (
            <ConnectedRouter history={history}>
              <Switch>
                {map(authRoutes, (route, index) => (
                  <Route {...route} key={`auth-page-${index}`} />
                ))}
              </Switch>
              <Layout>
                <LicenseExpire isTrial={isTrial} expireDate={expireDate} />
                <Switch>
                  {map(routes, ({ isPrivate, ...props }, index) =>
                    isPrivate ? (
                      <PrivateRoute {...props} key={index} />
                    ) : (
                      <Route {...props} key={index} />
                    )
                  )}
                  <Redirect from={Path.MAIN} to={Path.DOCS} />
                </Switch>
              </Layout>
            </ConnectedRouter>
          )}
        </SettingsProvider>
      </Provider>
    </div>
  );
}

export default App;
